var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameDuration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3598.32 3069.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "m 705.51717,463.95698 c 593.36833,-587.187 1550.88383,-582.16624 2138.11293,11.24491 l 358.2428,-354.51112 3.3814,949.11663 -958.5961,-3.8526 358.193,-354.46178 C 2148.0733,249.99205 1403.3587,246.0926 941.8579,702.7855 c -461.5364,456.7285 -465.43562,1201.443 -8.7003,1662.9863 456.6857,461.4941 1201.4003,465.3933 1662.9367,8.665 230.5262,-228.0402 346.1393,-529.1262 346.497,-829.7052 l 337.3842,1.8088 c -0.8673,388.4357 -148.9624,771.3419 -447.4981,1066.7674 C 2239.0242,3200.4943 1281.5088,3195.4737 694.32881,2602.1127 107.09982,2008.7014 112.10624,1051.186 705.51717,463.95698 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "m 1851.13,864.3 h -252 v 839.92 l 718.98,426.67 120.95,-203.24 -587.93,-349.46 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameDuration);
export default __webpack_public_path__ + "static/media/icon-game-duration.eb91780999d4261aa70ecde49dd04fcf.svg";
export { ForwardRef as ReactComponent };